import React, { useEffect, useRef, useState } from "react";
import HeaderTur1 from "./HeaderTur1";
import "./FormularioStyle.css"
import { useNavigate, useSearchParams } from "react-router-dom";
import Commons from "./Common/Commons";
import ServiceBackend from "../Services/ServiceBackend";
import CanvasDraw from "react-canvas-draw";
import { Spinner } from "reactstrap";


const FormularioTur1 = () => {

    const [datos, setDatos] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const [tipoForm, setTipoForm] = useState("");
    const [dia, setDia] = useState(0);
    const [mes, setMes] = useState(0);
    const [anio, setAnio] = useState(0);
    const firmaTur = useRef(null);
    const [errors, setErrors] = useState([]);
    const [valid, setValid] = useState(false);
    const [docLoading, setDocLoading] = useState(false)
    const [fileRecibo, setFileRecibo] = useState();
    const [fileDNI, setFileDNI] = useState();
    const [fileDNI2, setFileDNI2] = useState();
    const [sendLoading, setSendLoading] = useState(false);
    const navigate = useNavigate();
    const setCurrent = () =>{
        const now = new Date();
        setDia(now.getDate());
        setMes(now.getMonth()+1);
        setAnio(now.getFullYear());
    }

    const changeHandler = (e) =>{
        const { name, value } = e.target;
        setDatos({
          ...datos,
          [name]: value,
        });
      };

      const validateFileSize = (f, fileFieldName, errorList) => {
        if (f!=null && f.size>10000000) {
        errorList.push(fileFieldName)
        setValid(false)
    }
    }

      const handleSubmit = () =>{
        if (validateForm()) {
            setSendLoading(true);
            fillCondicionFields();
        var firmaStr  = firmaTur.current.canvasContainer.childNodes[1].toDataURL();
        ;    
        ServiceBackend.doThePostTurismo(datos, firmaStr, fileRecibo, fileDNI, fileDNI2)
        .then((resp)=> { 
            console.log(resp);
            setSendLoading(false);
            navigate("/done");
            
        })
        .catch((er)=> {
            console.log(er); 
            setSendLoading(false);  
            if (er!=null && er.response!=null && er.response.data!=null && er.response.data.message!=null)
            alert(er.response.data.message);
        else
            alert("Servicio no disponible, intente más tarde");
        })
        ; }
    }

    const getErrorMessageField = (fieldname) => {
        if (errors.includes(fieldname))
            return "Debe completar este campo"; 
        else
            return "";
    } 

    const getNonDNIMessageField = (fieldname) => {
        if (errors.includes(fieldname))
            return "Debe ingresar un DNI existente"; 
        else
            return "";
    } 


    const getErrorFirmaMessageField = (fieldname) => {
        if (errors.includes(fieldname))
            return "Deberá firmar aquí"; 
        else
            return "";
    }

    const validateForm = () => {
        setValid(true);
        var errorList= new Array();
        
        Commons.validateField(datos.nombreapellido, "nombreapellido", errorList, setValid)
        Commons.validateField(datos.afiliado, "afiliado", errorList, setValid);
        Commons.validateField(datos.dni, "dni", errorList, setValid);
        Commons.validateField(datos.seccional, "seccional",errorList, setValid);
        Commons.validateField(datos.empresa, "empresa", errorList, setValid);
        Commons.validateField(datos.domicilio, "domicilio", errorList, setValid);
        Commons.validateField(datos.edad, "edad", errorList, setValid);
        Commons.validateField(datos.nacionalidad, "nacionalidad", errorList, setValid);
        Commons.validateField(datos.telfijo, "telfijo", errorList, setValid);
        Commons.validateField(datos.cel, "cel", errorList, setValid);
        Commons.validateField(datos.desde, "desde", errorList, setValid);
        Commons.validateField(datos.hasta, "hasta", errorList, setValid);
        Commons.validateField(datos.noches, "noches", errorList, setValid);
        Commons.validateField(datos.plazas, "plazas", errorList, setValid);
        //Commons.validateField(datos.restaabonar, "restaabonar", errorList, setValid);
        //Commons.validateField(datos.senia, "senia", errorList, setValid);
        //Commons.validateField(datos.importetotal, "importetotal", errorList, setValid);
        Commons.validateField(fileRecibo, "fileRecibo", errorList, setValid);
        Commons.validateField(fileDNI, "fileDNI", errorList, setValid);

        Commons.validateField(fileDNI2, "fileDNI2", errorList, setValid);

        Commons.validateFirmaField(firmaTur, "firmaTur", errorList, setValid);
        validateFileSize(fileRecibo, "fileReciboSize", errorList);
        validateFileSize(fileDNI, "fileDNISize", errorList);
        validateFileSize(fileDNI2, "fileDNI2Size", errorList);
        fillNullAmounts();
        console.log(errorList);
        setErrors(errorList);
    
        
        return errorList.length==0;
    }

    const handleFileUploadRecibo = (e) => {
        setFileRecibo(e.target.files[0]);
}

const getErrorMessageFieldSize = (fieldname) => {
    if (errors.includes(fieldname))
        return "El tamaño del archivo debe ser menor a 10MB"; 
    else
        return "";
} 

const calculateDates = () => {
    if (datos.desde!=null && datos.hasta!=null && datos.desde!="" && datos.hasta!=null) {
        let date1= new Date(datos.desde);
        let date2 = new Date(datos.hasta);
        let Difference_In_Time =
    date2.getTime() - date1.getTime();
        let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
        setDatos({
            ...datos,
            noches: Difference_In_Days>0?Difference_In_Days:"",
        })
    } 
}

const calculateAmounts = () => {
    if (datos.importetotal!=null && datos.senia!=null && datos.importetotal!="" && datos.senia!="") {
         let Difference_In_Money = datos.importetotal - datos.senia;
        setDatos({
            ...datos,
            restaabonar: Difference_In_Money>=0?Difference_In_Money:"",
        })
    } 
    else
    setDatos({
        ...datos,
        restaabonar: "",
    })

}

const fillNullAmounts =() => {
    if (datos.importetotal==null || datos.importetotal=="")
        datos.importetotal="0";
    if (datos.senia==null || datos.senia=="")
    datos.senia="0";
if (datos.restaabonar==null || datos.restaabonar=="")
datos.restaabonar="0";
} 

const dateFieldsBlur = (e) => {
    calculateDates();
}

const amountFieldBlur = (e) =>{
    calculateAmounts();
}

const handleFileUploadDNI1 = (e) => {
setFileDNI(e.target.files[0]);
}

const handleFileUploadDNI2 = (e) => {
setFileDNI2(e.target.files[0]);
}

    const fillFields = () => {
        setDatos({
         ...datos,
         seccional:searchParams.get("seccional"),
         afiliado:searchParams.get("afiliado"),
         nombreapellido: searchParams.get("nombreapellido"),
         domicilio: searchParams.get("domicilio"),
         email: searchParams.get("email"),
         telfijo: searchParams.get("tel"),
         edad: searchParams.get("edad"),
         fechanac: searchParams.get("fechanac"),
         nacionalidad: searchParams.get("nacionalidad"),
         estadocivil: searchParams.get("estcivil"),
         empresa: searchParams.get("empresa"),
         cuil: searchParams.get("cuil"),
         cel: searchParams.get("cel"),
         dni: searchParams.get("dni"),
         ametia: "SI",
         solicitaLugar: "Córdoba",
         nrotramite: randomIntFromInterval(10000000, 99999999),
         
 
 
 
        })
    }

    const fillCondicionFields = () => {
        datos.f1condicion = datos.f1parentesco!=null?datos.f1tcondicion+" - "+datos.f1parentesco:datos.f1tcondicion;
        datos.f2condicion = datos.f2parentesco!=null?datos.f2tcondicion+" - "+datos.f2parentesco:datos.f2tcondicion;
        datos.f3condicion = datos.f3parentesco!=null?datos.f3tcondicion+" - "+datos.f3parentesco:datos.f3tcondicion;
        datos.f4condicion = datos.f4parentesco!=null?datos.f4tcondicion+" - "+datos.f4parentesco:datos.f4tcondicion;
        datos.f5condicion = datos.f5parentesco!=null?datos.f5tcondicion+" - "+datos.f5parentesco:datos.f5tcondicion;
        
    }

    const validateDNIEntered = (e) => {
        if (e.target.value==undefined || e.target.value==""){
            setErrors([]);
            return;
        }
        setDocLoading(true)
        ServiceBackend.validateDNI(e.target.value)
        .then((resp)=>{
            console.log("Fue por ok");
            console.log(resp);
            console.log(resp.data)
            
            if (resp.data=="" || resp.data==undefined)
            {
                setErrors(["dniexist"]);
                setDatos({
                    ...datos,
                    dni: ""
                })
            }
        else
            {
                setErrors([]);
                fillDatosFromEndpoint(resp.data);
            }
            setDocLoading(false);

        })
        .catch((err)=>{
            console.log("Fue por error");
            console.log(err);
            setErrors(["dniexist"]);
            setDatos({
                ...datos,
                dni: ""
            })
            setDocLoading(false);
            
        })
    } 

    const fillDatosFromEndpoint = (dniResp) => {
        setDatos({
            ...datos,
            nombreapellido: dniResp.nombre + " " + dniResp.apellido,
            afiliado: dniResp.id,
            seccional: dniResp.delegacion,
            empresa: dniResp.codempresa,
            edad: convertFecha(dniResp.fecnac),
            email: dniResp.mail,
            cel: dniResp.celular,
            telfijo: dniResp.telefono,
            domicilio: dniResp.calle+" "+ dniResp.puerta+" "+dniResp.piso+" "+dniResp.depto+" "+dniResp.localidad,
            estadocivil: dniResp.civil,
            nacionalidad: dniResp.nacionalidad,


        })
    }

    function convertFecha(input) {
        if (input==undefined || input=="") return "";
        if (input.includes("/")) return input.substring(6,10)+"-"+input.substring(3,5)+"-"+input.substring(0,2);
        return input;

    }

    function randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
      }

      const resetFirma = () => {
        firmaTur.current.clear();
    }

    useEffect(()=>{
        setCurrent();
        fillFields();
        
            },[]);


    return(
        <>
       <div className="container-fluid margin20 needs-validation">
        <HeaderTur1/>
    <div className="row">
        <h1>
            SOLICITUD DE TURISMO
        </h1>
    </div>

    <div className="row">
        <div className="col alignRight"> BUENOS AIRES, &nbsp;
       {dia} 
        / {mes}
        / {anio}
    </div>
    </div>
    
    <div className="row">
    <div className="col-sm-3 form-group">
    <label className="control-label">Documento nro:</label>
    <input type="number" className="form-control" placeholder="" id="dni"
    name="dni" min="0" max="99999999" value={datos.dni} onChange={changeHandler} onBlur={validateDNIEntered}/>
        <div className="formError">{getErrorMessageField("dni")}</div>
        <div className="formError">{getNonDNIMessageField("dniexist")}</div>
        <div className="formError">{docLoading?<Spinner color="secondary"/>:""}</div>

</div>
<div className="col-sm-6 form-group">
    <label className="control-label">Nombre y apellido:</label>
    <input type="text" className="form-control" placeholder="" id="nombreapellido"
    
    name="nombreapellido"  value={datos.nombreapellido} maxlength="50" onChange={changeHandler}/>
    <div className="formError">{getErrorMessageField("nombreapellido")}</div>
</div>
<div className="col-sm-3 form-group">
    <label className="control-label">Afiliado nro:</label>
    <input type="number" className="form-control" placeholder="" id="afiliado"
    name="afiliado" maxlength="20" value={datos.afiliado} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("afiliado")}</div>

</div>

</div>

<div className="row">
<div className="col-sm-4 form-group">
    <label className="control-label">Seccional</label>
    <input type="text" className="form-control" placeholder="" id="seccional"
    name="seccional" maxlength="30" value={datos.seccional} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("seccional")}</div>

</div>
<div className="col-sm-4 form-group">
    <label className="control-label">Empresa</label>
    <input type="text" className="form-control" placeholder="" id="empresa"
    name="empresa" maxlength="40" value={datos.empresa} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("empresa")}</div>

</div>
</div>


<div className="row">
<div className="col-sm-3 form-group">
    <label className="control-label">Estado civil:</label>
    <input type="text" className="form-control" placeholder="" id="estadocivil"
    name="estadocivil" maxlength="30" value={datos.estadocivil} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("estadocivil")}</div>

</div>
<div className="col-sm-3 form-group">
    <label className="control-label">Fecha Nacimiento:</label>
    <input type="date" className="form-control" placeholder="" id="edad"
    name="edad" maxlength="2" value={datos.edad} onChange={changeHandler}
/>    <div className="formError">{getErrorMessageField("edad")}</div>

</div>
<div className="col-sm-3 form-group">
    <label className="control-label">Nacionalidad:</label>
    <input type="text" className="form-control" placeholder="" id="nacionalidad"
    name="nacionalidad" maxlength="20" value= {datos.nacionalidad} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("nacionalidad")}</div>

</div>
<div className="col-sm-3 form-group">
    <label className="control-label">Tel. Fijo:</label>
    <input type="text" className="form-control" placeholder="" id="telfijo"
    name="telfijo" maxlength="20" value={datos.telfijo} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("telfijo")}</div>

</div>
</div>

<div className="row">
<div className="col-sm-4 form-group">
            <label className="control-label">Email: </label>
            <input type="text" className="form-control" placeholder="" id="email"
                name="email" maxLength="50" onChange={changeHandler} value={datos.email}/>
                <div className="formError">{getErrorMessageField("email")}</div>
            </div>

            <div className="col-sm-4 form-group">
            <label className="control-label">Cel: </label>
            <input type="text" className="form-control" placeholder="" id="cel"
                name="cel" maxLength="11" onChange={changeHandler} value={datos.cel}/>
                <div className="formError">{getErrorMessageField("cel")}</div>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Domicilio: </label>
            <input type="text" className="form-control" placeholder="" id="domicilio"
                name="domicilio" maxLength="50" onChange={changeHandler} value={datos.domicilio}/>
                <div className="formError">{getErrorMessageField("domicilio")}</div>
            </div>

          
</div>


<div className="row">
<div class="col-sm-4 form-group">
    <div class="i-checks">
        <label class="control-label"> Solicita turismo en</label>
        <select class="form-control" name="solicitaLugar" value={datos.solicitaLugar} onChange={changeHandler} >
            <option>Córdoba</option>
            <option>Mar del Plata</option>
            <option>Bariloche</option>
            <option>San Clemente</option>
            <option>Hotel Ezeiza</option>
            <option>Dormis Ezeiza</option>

        </select>
   </div>
</div>
</div>

<div className="row">
<div className="col-sm-4 form-group">
    <label className="control-label">Ingreso:  (14hs)</label>
    <input type="date" className="form-control" placeholder="" id="desde"
    name="desde" maxlength="30" value={datos.desde} onChange={changeHandler} onBlur={dateFieldsBlur}/>
        <div className="formError">{getErrorMessageField("desde")}</div>

</div>
<div className="col-sm-4 form-group">
    <label className="control-label">Egreso:  (10hs)</label>
    <input type="date" className="form-control" placeholder="" id="hasta"
    name="hasta" maxlength="20" value={datos.hasta} onChange={changeHandler} onBlur={dateFieldsBlur}/>
        <div className="formError">{getErrorMessageField("hasta")}</div>

</div>
</div>

<div className="row">
<div className="col-sm-4 form-group">
    <label className="control-label">Cantidad de noches:</label>
    <input type="number" className="form-control" placeholder="" id="noches"
    name="noches" maxlength="2" value={datos.noches} onChange={changeHandler} readOnly disabled/>
        <div className="formError">{getErrorMessageField("noches")}</div>

</div>
<div className="col-sm-4 form-group">
    <label className="control-label">Cantidad de plazas (personas):</label>
    <input type="number" className="form-control" placeholder="" id="plazas"
    name="plazas" maxlength="2" value={datos.plazas} onChange={changeHandler}/>
        <div className="formError">{getErrorMessageField("plazas")}</div>

</div>
<div class="col-sm-4 form-group">
        <label class="control-label"> AMETIA</label>
        <select class="form-control" name="ametia" value={datos.ametia} onChange={changeHandler} >
            <option>SI</option>
            <option>NO</option>
          
        </select>
   </div>
</div>

<h3>
ACOMPAÑANTES
</h3>

<div className="row">
    <div className="col-sm-12-form-group">
        Acompañante 1
    </div>
</div>

<div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f1apellidonombre"
                name="f1apellidonombre" maxLength="40" value={datos.f1apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">DNI:</label>
            <input type="text" className="form-control" placeholder="" id="f1dni"
                name="f1dni" maxLength="13"  value={datos.f1dni} onChange={changeHandler}/>
        </div>
        <div className="col-sm-1 form-group">
            <label className="control-label">Edad:</label>
            <input type="text" className="form-control" placeholder="" id="f1edad"
                name="f1edad1" maxLength="2"  value={datos.f1edad} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f1parentesco"
                name="f1parentesco"  value={datos.f1parentesco} onChange={changeHandler}/>
        </div>

        <div className="col-sm-3 form-group">
            <label className="control-label">Condición:</label>
            <input type="text" className="form-control" placeholder="" id="f1tcondicion"
                name="f1tcondicion"  value={datos.f1tcondicion} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
    <div className="col-sm-12-form-group">
        Acompañante 2
    </div>
</div>
    <div className="row">
    <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f2apellidonombre"
                name="f2apellidonombre" maxLength="40" value={datos.f2apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">DNI:</label>
            <input type="text" className="form-control" placeholder="" id="f2dni"
                name="f2dni" maxLength="13"  value={datos.f2dni} onChange={changeHandler}/>
        </div>
        <div className="col-sm-1 form-group">
            <label className="control-label">Edad:</label>
            <input type="text" className="form-control" placeholder="" id="f2edad"
                name="f2edad" maxLength="2"  value={datos.f2edad} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f2parentesco"
                name="f2parentesco"  value={datos.f2parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Condición:</label>
            <input type="text" className="form-control" placeholder="" id="f2tcondicion"
                name="f2tcondicion"  value={datos.f2tcondicion} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
    <div className="col-sm-12-form-group">
        Acompañante 3
    </div>
</div>

    <div className="row">
    <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f3apellidonombre"
                name="f3apellidonombre" maxLength="40" value={datos.f3apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">DNI:</label>
            <input type="text" className="form-control" placeholder="" id="f3dni"
                name="f3dni" maxLength="13"  value={datos.f3dni} onChange={changeHandler}/>
        </div>
        <div className="col-sm-1 form-group">
            <label className="control-label">Edad:</label>
            <input type="text" className="form-control" placeholder="" id="f3edad"
                name="f3edad" maxLength="2"  value={datos.f3edad} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f3parentesco"
                name="f3parentesco"  value={datos.f3parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Condición:</label>
            <input type="text" className="form-control" placeholder="" id="f3tcondicion"
                name="f3tcondicion"  value={datos.f3tcondicion} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
    <div className="col-sm-12-form-group">
        Acompañante 4
    </div>
</div>
    <div className="row">
    <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f4apellidonombre"
                name="f4apellidonombre" maxLength="40" value={datos.f4apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">DNI:</label>
            <input type="text" className="form-control" placeholder="" id="f4dni"
                name="f4dni" maxLength="13"  value={datos.f4dni} onChange={changeHandler}/>
        </div>
        <div className="col-sm-1 form-group">
            <label className="control-label">Edad:</label>
            <input type="text" className="form-control" placeholder="" id="f4edad"
                name="f4edad" maxLength="2"  value={datos.f4edad} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f4parentesco"
                name="f4parentesco"  value={datos.f4parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Condición:</label>
            <input type="text" className="form-control" placeholder="" id="f4tcondicion"
                name="f4tcondicion"  value={datos.f4tcondicion} onChange={changeHandler}/>
        </div>
    </div>

    <div className="row">
    <div className="col-sm-12-form-group">
        Acompañante 5
    </div>
</div>

    <div className="row">
    <div className="col-sm-4 form-group">
            <label className="control-label">Apellido y nombre:</label>
            <input type="text" className="form-control" placeholder="" id="f5apellidonombre"
                name="f5apellidonombre" maxLength="40" value={datos.f5apellidonombre} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">DNI:</label>
            <input type="text" className="form-control" placeholder="" id="f5dni"
                name="f5dni" maxLength="13"  value={datos.f5dni} onChange={changeHandler}/>
        </div>
        <div className="col-sm-1 form-group">
            <label className="control-label">Edad:</label>
            <input type="text" className="form-control" placeholder="" id="f5edad"
                name="f5edad" maxLength="2"  value={datos.f5edad} onChange={changeHandler}/>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Parentesco:</label>
            <input type="text" className="form-control" placeholder="" id="f5parentesco"
                name="f5parentesco"  value={datos.f5parentesco} onChange={changeHandler}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Condición:</label>
            <input type="text" className="form-control" placeholder="" id="f5tcondicion"
                name="f5tcondicion"  value={datos.f5tcondicion} onChange={changeHandler}/>
        </div>
    </div>
    <div>
            <h3>&nbsp;</h3>
        </div>


<div className="row">
        <div className="col-sm-4 form-group">
        <label className="control-label">Importe total:</label>
        <input type="number" className="form-control" placeholder="" id="importetotal"
                name="importetotal"  value={datos.importetotal} onChange={changeHandler} onBlur={amountFieldBlur}/>
                <div className="formError">{getErrorMessageField("importetotal")}</div>
        </div><div className="col-sm-4 form-group">
                <label className="control-label">Seña:</label>
        <input type="number" className="form-control" placeholder="" id="senia"
                name="senia"  value={datos.senia} onChange={changeHandler} onBlur={amountFieldBlur}/>
                <div className="formError">{getErrorMessageField("senia")}</div>
            </div>   <div className="col-sm-4 form-group"> 
                <label className="control-label">Resta abonar:</label>
        <input type="number" className="form-control" placeholder="" id="restaabonar"
                name="restaabonar"  value={datos.restaabonar} onChange={changeHandler} readOnly disabled/>
                <div className="formError">{getErrorMessageField("restaabonar")}</div>
</div>
        </div>

      
<div className="row">
        <div className="col-sm-8 form-group"><span className="letraChica">
            Nota: El pago se realizará mediante transferencia, con el 50% del total queda reservada su plaza.
            La última cuota deberá ser cancelada 20 días antes de la fecha de ingreso al hotel.
            Los importes están sujetos a modificaciones.</span>
        </div>
</div>
        
        <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Foto último recibo de sueldo:</label>
            <input type="file"  accept="image/jpeg, image/png, application/pdf, image/jpg" className="form-control" placeholder="" id="recibosueldo"
                name="recibosueldo" maxLength="30" value={datos.recibosueldo} onChange={handleFileUploadRecibo}/>
                                <div className="formError">{getErrorMessageField("fileRecibo")}
                                 {getErrorMessageFieldSize("fileReciboSize")}</div>

        </div>
       
        <div className="col-sm-4 form-group">
            <label className="control-label">Foto DNI frente:</label>
            <input type="file"  accept="image/jpeg, image/png, application/pdf, image/jpg" className="form-control" placeholder="" id="fotodni"
                name="fotodni" maxLength="30" onChange={handleFileUploadDNI1} value={datos.fotodni}/>
                                <div className="formError">{getErrorMessageField("fileDNI")}
                                 {getErrorMessageFieldSize("fileDN2Size")}</div>

        </div>
        <div className="col-sm-4 form-group">
            <label className="control-label">Foto DNI dorso:</label>
            <input type="file"  accept="image/jpeg, image/png, application/pdf, image/jpg"  className="form-control" placeholder="" id="fotodni2"
                name="fotodni2" maxLength="30" onChange={handleFileUploadDNI2} value={datos.fotodni2}/>
                                <div className="formError">{getErrorMessageField("fileDNI2")}
                                { getErrorMessageFieldSize("fileDNI2Size")}</div>

        </div>
</div>
        <div className="row">
            <div className="col">&nbsp;</div>
        </div>
        <div className="row">
            <div className="col-sm-4">&nbsp;</div>
        <div className="col-sm-4 form-group">
            <label className="control-label">Firma del solicitante:</label>
            <CanvasDraw brushRadius={1} lazyRadius={0}  canvasHeight={150}
            style={{border:"1px solid black",width:"100%"}}
            ref={firmaTur}
    />      <div className="formError">{getErrorFirmaMessageField("firmaTur")}</div></div>
<div className="col-sm-4">&nbsp;</div>
</div>
<div className="row">
            <div className="col-12 alignCenter topTo10 ">
                <input type="button" className="btn btn-success firmas" value="Limpiar" onClick={resetFirma}></input>
            </div><br/>
            <div className="col-12 alignCenter topTo10 ">
                <input type="submit" className="btn btn-primary btnEnviar" value="Enviar solicitud" onClick={handleSubmit}/> 
            </div><br/>
            <div className="col-12 alignCenter topTo10 ">
            {sendLoading?<Spinner color="info"/>:""}
            </div>
            
            </div>
        </div><br/><br/>





    </>);
}

export default FormularioTur1;